import PrinterV2 from '../../printing/printer'
import PrinterToaster from '../../printing/toaster'

export const MAX_PRINTABLE_SKU_LENGTH = 27
export const SKU_TOO_LONG_PRINT_MESSAGE = `Product SKU is too long. Shorten to ${MAX_PRINTABLE_SKU_LENGTH} characters or less to print`

export interface TryPrintExpressListProductLabelResult {
  ok: boolean
  skuTooLong?: boolean
}

export async function tryPrintExpressListProductLabel({
  productId,
  sku
}: {
  productId: number
  sku: string | null
}): Promise<TryPrintExpressListProductLabelResult> {
  if (sku && sku.length > MAX_PRINTABLE_SKU_LENGTH) {
    PrinterToaster.show({
      intent: 'danger',
      message: SKU_TOO_LONG_PRINT_MESSAGE
    })
    return { ok: false, skuTooLong: true }
  }

  try {
    const printer = new PrinterV2()
    const printed = await printer.printProductLabelFromId([productId])
    return { ok: printed }
  } catch {
    return { ok: false }
  }
}
